module.exports = "<p>configure works!</p>\n"